export default {
  name: 'TitleTab',
  props: {
    titleTabConfig: Array
  },
  methods: {
    tabTitleItemClickHandler(e) {
      let tabType = e.currentTarget.dataset.tabType;

      this.$emit('click-tab', { tabType });
    }
  }
};
